import SwiperCore, { Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

SwiperCore.use([Thumbs]);

export default function B() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const LOCAL_SITES: string[] = ['za', 'kr'];
    const IS_AU: string[] = ['us', 'ca'];
    const IMG_MAP: any = {
        us: '',
        kr: '_kr',
    };
    let cards: any = [
        {
            img: `/responsive/picture/vanlife-roadtrips/2_1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgMobile: `/responsive/picture/vanlife-roadtrips/2_1_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            title: t('secB_tab1_title'),
            desc: t('secB_tab1_desc'),
        },
        {
            img: `/responsive/picture/vanlife-roadtrips/2_2${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
            imgMobile: `/responsive/picture/vanlife-roadtrips/2_2_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
            title: t('secB_tab2_title'),
            desc: t('secB_tab2_desc'),
        },
        {
            img: `/responsive/picture/vanlife-roadtrips/2_3${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgMobile: `/responsive/picture/vanlife-roadtrips/2_3_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            title: t('secB_tab3_title'),
            desc: t('secB_tab3_desc'),
        },
        {
            img: `/responsive/picture/vanlife-roadtrips/2_4${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
            imgMobile: `/responsive/picture/vanlife-roadtrips/2_4_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
            title: t('secB_tab4_title'),
            desc: t('secB_tab4_desc'),
        },
    ];

    if (locale === 'au') {
        cards = [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716532793049/2_1_au.png',
                imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716534831522/2_1_768_au.png',
                title: t('secB_tab1_title'),
                desc: t('secB_tab1_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_1_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
                title: t('secB_tab2_title'),
                desc: t('secB_tab2_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_3${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_3_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                title: t('secB_tab3_title'),
                desc: t('secB_tab3_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_4${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_4_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
                title: t('secB_tab4_title'),
                desc: t('secB_tab4_desc'),
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716532728623/2_5_au.png',
                imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716533824350/2_5_768_au.png',
                title: t('secB_tab5_title'),
                desc: t('secB_tab5_desc'),
            },
        ];
    } else if (locale === 'uk') {
        cards.splice(1, 1);
    } else if (IS_AU) {
        cards.push({
            img: 'https://websiteoss.ecoflow.com/upload/image/1754363285055/Frame%201612690202.jpg',
            imgMobile: 'https://websiteoss.ecoflow.com/upload/image/1754363285051/m_img01.jpg',
            title: t('secB_tab5_title'),
            desc: t('secB_tab5_desc'),
        });
    }

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div id="vanlife-roadtrips-B" className={`vanlife-roadtrips-B ${css['vanlife-roadtrips-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secB_title')}</p>
                </div>
                <div className="swiper-container">
                    <Swiper
                        className="swiper-box"
                        effect="fade"
                        modules={[Thumbs]}
                        pagination={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        onSlideChange={(swiper) => setActive(swiper.activeIndex)}
                    >
                        {cards?.map((item: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                <div className="item-img">
                                    <EFPicture src={item?.img} alt={item?.title} />
                                </div>
                                <div className="card-text">
                                    <p className="card-title">{item?.title}</p>
                                    <p className="card-desc">{item?.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <Swiper className="swiper-thumb-box" spaceBetween={24} onSwiper={setThumbsSwiper} slidesPerView={'auto'} initialSlide={0}>
                        {cards?.map((item: any, k: number) => (
                            <SwiperSlide className={`swiper-thumb-item ${active === k ? 'active' : ''}`} key={k}>
                                <div className="item-thumb-img">
                                    <EFPicture src={item?.imgMobile} alt={item?.title} />
                                </div>
                                <div className="card-thumb-mask"></div>
                                <p className="card-thumb-title">{item?.title}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="tabs-container">
                    <div className="tab-img">
                        <EFPicture src={cards[active]?.imgMobile} alt={cards[active]?.title} />
                    </div>
                    <div className="tabs-box">
                        <ul className="tabs-inner" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                            {cards?.map((card: any, k: number) => (
                                <li className={`tab-item ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                                    {card?.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="tab-desc">{cards[active]?.desc}</p>
                </div>
            </div>
        </div>
    );
}
